<style lang="less" scoped>
    .btn-right-mes {
        margin-left: 10px;
        line-height: 32px;
    }
    .withdrawal-mes {
        margin: 0px 0px 16px 30px;
    }
    .red-tip {
        color: #F56C6C;
        font-size: 12px;
        margin-left: 30px;
    }
    /deep/ .hide .el-upload--picture-card {
      display: none;
    }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">提现管理</div>
            <ZD-list-querys>
                <template slot="inputs">
                        <div class="list-query-child-div flex">
                            <div class="query-title-div">运营商</div>
                            <div class="query-inputs-div flex-1">
                                <el-input size="small" v-model="queryInfo.dealerName" placeholder="请输入内容" clearable @keyup.enter.native="getListData(pagination,true)"></el-input>
                            </div>
                        </div>
                        <div class="list-query-child-div flex">
                            <div class="query-title-div">提现状态</div>
                            <div class="query-inputs-div flex-1">
                                <el-select class="full-width" size="small" v-model="queryInfo.chashOutStatus" clearable @keyup.enter.native="getListData(pagination,true)">
                                    <el-option label="已受理" value="02"></el-option>
                                    <el-option label="已提现" value="03"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="list-query-child-div flex">
                            <div class="query-title-div">订单编号</div>
                            <div class="query-inputs-div flex-1">
                                <el-input size="small" v-model="queryInfo.cashOutNo" placeholder="请输入内容" clearable @keyup.enter.native="getListData(pagination,true)"></el-input>
                            </div>
                        </div>
                    </template>
                    <template slot="actions">
                        <button class="common-bg-button" @click="getListData(pagination,true)">搜 索</button>
                        <button class="common-empty-button" @click="reset()">重 置</button>
                    </template>
            </ZD-list-querys>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
            <el-dialog width="30%" title="提现结算" :visible.sync="formDialogVisible">
                <div class="withdrawal-mes">运营商：{{rowObj.dealerName}}</div>
                <div class="withdrawal-mes">提现订单编号：{{rowObj.cashOutNo}}</div>
                <div class="withdrawal-mes">提现申请人：{{rowObj.applyBy}}</div>
                <div class="withdrawal-mes">申请人电话：{{rowObj.applyByPhone}}</div>
                <div class="withdrawal-mes">提现申请时间：{{rowObj.applyTime}}</div>
                <div class="withdrawal-mes">提现状态：{{rowObj.chashOutStatusName}}</div>
                <div class="withdrawal-mes">申请金额：{{rowObj.applyMoney}}元</div>
                <div class="withdrawal-mes">提现银行卡尾号：{{rowObj.applyBankCard}}</div>
                <el-form :model="dialogForm" ref="dialogForm" :rules="pageConfig.formRules" v-if ="rowObj.chashOutStatus != '03'">
                    <el-form-item label="成功付款时间" prop="chashOutFinshTime">
                        <el-date-picker style="width:320px;" v-model="dialogForm.chashOutFinshTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" size="small"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="上传打款凭证">
                        <el-upload action="" :http-request="toUploadLocationImg" :limit="1" list-type="picture-card" :on-remove="handleLocationImgRemove" :on-preview="handlePictureCardPreview" :file-list="locationImage" :on-change="handleEditChange" :before-upload="beforeAvatarUpload" :class="{hide:hideUploadEdit}">
                            <i class="el-icon-plus"></i>
                            <div slot="tip" class="el-upload__tip">(最多上传1张,且不超过5MB)</div>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                            <el-input style="width:320px;" size="small" v-model="dialogForm.remark"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="formDialogVisible = false" size="small" v-if ="rowObj.chashOutStatus != '03'">取 消</el-button>
                    <el-button type="primary" size="small" @click="submitForm('dialogForm')" v-if="rowObj.chashOutStatus != '03'">确 定</el-button>
                    <el-button @click="formDialogVisible = false" size="small" v-if="rowObj.chashOutStatus == '03'">关闭</el-button>
                </div>
                <div class="" v-if="rowObj.chashOutStatus == '03'">
                   <div class="withdrawal-mes">操作人：{{rowObj.lastModifiedByName}}</div>
                    <div class="withdrawal-mes">操作时间：{{rowObj.lastModifiedWhen}}</div>
                    <div class="withdrawal-mes">成功付款时间：{{rowObj.chashOutFinshTime}}</div>
                    <div class="withdrawal-mes">打款凭证：
                        <el-upload action="" :http-request="toUploadLocationImg" :limit="1" list-type="picture-card" :on-remove="handleLocationImgRemove" :on-preview="handlePictureCardPreview" :file-list="locationImage" :on-change="handleEditChange" :class="{hide:hideUploadEdit}" disabled>
                            <i class="el-icon-plus"></i>
                            <div slot="tip" class="el-upload__tip">(最多上传1张)</div>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible" append-to-body>
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </div>
                    <div class="withdrawal-mes">备注：{{rowObj.remark}}</div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    import dateUtil from '../../../utils/dateUtils'
    export default {
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                queryInfo: {},  //标签页与 搜索框
                form: {},   //未使用
                rowObj: {}, //选中表单数据
                operates: {
                    width: 150,
                    fixed: "right",
                    list: [{
                        id: "review",
                        label: "详情",
                        type: "primary",
                        show: true,
                        disabled: false,
                        method: (index, row) => {
                            this.rowObj = row;
                            this.formDialogVisible = true;
                            this.dialogForm = this.rowObj;
                            this.hideUploadEdit = false;
                            if(this.rowObj.chashOutStatus == '03'){
                                this.locationImage = [{
                                    url:this.rowObj.voucher
                                }]
                                this.stationLocationFile = this.locationImage;
                                this.hideUploadEdit = true
                            }else {
                                this.stationLocationFile = null;
                                this.locationImage = [];
                                this.dialogForm.chashOutFinshTime = ''
                            }
                        }
                    }, ]
                }, // 列操作按钮
                dialogVisible: false, //银行卡图片弹窗
                userInfo: {},//用户信息
                applyDate: '', //未使用
                tipFlag: false,//未使用
                dialogForm: {  //打款信息
                    //remark: '',
                    chashOutFinshTime: ''
                },
                locationImage: [], // 打款凭证图
                stationLocationFile:null,// 打款凭证图
                dialogImageUrl: '',// 银行卡图片地址
                formDialogVisible: false,  //提现信息
                appStationFiles: [], //未使用
                hideUploadEdit:false, //控制是否上传图片按钮
            }
        },
        methods: {
            init() {
                this.userInfo = this.$store.state.userInfo;
                this.getListData(this.pagination, true);
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    this.pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.$H.get(_, _.$A.finance.cashOut, _.queryInfo).then(res => {
                    _.tableData = res.data.data.cashOutEntityList.content || [];
                    _.pagination.total = res.data.data.cashOutEntityList.totalElements || 0;
                    _.$U.hideLoading(_);
                })
            },
            //删除打款凭证图片
            handleLocationImgRemove(file,fileList) {
                this.stationLocationFile = null;   
                let _ = this
                _.hideUploadEdit = fileList.length >= 1
            },
            //预览打款凭证
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            //上传图片信息
            toUploadLocationImg(param)  {         
                this.stationLocationFile = param.file;     
            },
            //每次上传图片触发
            handleEditChange(file, fileList) {
                let _ = this
                _.hideUploadEdit = fileList.length >= 1;
            },
            //限制图片大小
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 5;
                if (!isLt2M) {
                this.$message.error('上传打款凭证大小不能超过 5MB!');
                }
                return isLt2M;
            },
            // 表单提交
            submitForm(formName) {
                let _ = this;
                // 站点图片
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.stationLocationFile == null){
                            this.$U.error('请上传打款凭证图');
                            return;
                        }
                        _.dialogForm.reviewTime = _.dialogForm.chashOutFinshTime
                        _.dialogForm.chashOutStatus = '03';
                        let formData = new FormData();
                        Object.keys(_.dialogForm).forEach((key) => {
                            formData.append(key, _.dialogForm[key]);
                        });
                        formData.append('file',_.stationLocationFile);
                        console.log(_.stationLocationFile)
                        _.$H.post(_, _.$A.finance.updateCashout, formData).then(res => {
                            _.$U.success("提交成功")
                            _.formDialogVisible = false;
                            this.getListData(this.pagination,true);
                        })
                    }
                });
            },
            //重置
            reset(){
                this.pagination.current = 1;
                delete this.queryInfo.dealerName;
                delete this.queryInfo.chashOutStatus;
                delete this.queryInfo.cashOutNo;
                this.getListData(this.pagination,true);
            }
        },
        mounted() {
            this.init();
        }
    }
</script>